module.exports = __webpack_public_path__ + "img/home_btn_topbar_point_ecuador.4be9e2d2.png";